import { Component, OnInit, ViewChild, ElementRef, HostListener, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as echarts from 'echarts';
import { CoreService, HttpService, StatistiqueAvancementChapitreEL, StatistiqueModel, DialogService, QResult } from 'projects/lib-components/src/public_api';

@Component({
  selector: 'q-BarAvancement',
  templateUrl: './BarAvancementChapitre.component.html',
  styleUrls: ['./BarAvancementChapitre.component.css']
})



export class BarAvancementComponent implements OnInit, OnChanges {
  @ViewChild('graphtest', { static: false }) graphtest: ElementRef;
  myChart: any;
  AvancementChapitreEL: StatistiqueAvancementChapitreEL = new StatistiqueAvancementChapitreEL();


  @Input('IdChapitre') IdChapitre: number;
  @Input('IdCycle') IdCycle: number;

  constructor(
    protected IndParam: CoreService,
    protected http: HttpService,
    protected dialogservice: DialogService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (this.AvancementChapitreEL.ListAvancement && this.AvancementChapitreEL.ListAvancement.length > 0) {
      this.myChart.resize();
    }
  }

  ngOnInit(): void {}

  ngOnChanges(): void {
    const style: CSSStyleDeclaration = getComputedStyle(document.body);
    const Cmain: string = style.getPropertyValue('--c-main');
    const Csecondary: string = style.getPropertyValue('--c-secondary');
    const clightmain: string = style.getPropertyValue('--c-light-main');

    this.dialogservice.showSplash(true);

    this.http.getHttp<QResult<StatistiqueModel>>(`${this.IndParam.AppParams.apiUrl}api/statistique/el/GraphAvancementChapitre/${this.IdCycle}|${this.IdChapitre}`).subscribe((result: QResult<StatistiqueModel>) => {
      if (!result.HasError) {
        this.AvancementChapitreEL = result.Value.StatElearning.AvancementChapitreEL;

        setTimeout(() => {
          this.myChart = echarts.init(this.graphtest.nativeElement);

          this.myChart.setOption({
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'category',
              data: this.AvancementChapitreEL.ListModule,
              axisLabel: {
                interval: 0,
                formatter: function ( value: string, index: number ) {
                  if (value.length > 10) {
                    value = value.substring(0, 10) + '...';
                  }
                  return value;
                }
              }
            },
            yAxis: {
              type: 'value',
              min: 0,
              max: this.AvancementChapitreEL.NbApprenant,
            },
            series: [{
              data: this.AvancementChapitreEL.ListAvancement,
              type: 'bar',
              itemStyle: {
                normal: {
                  color: Cmain,
                  borderWidth: 3,
                  borderColor: '#ffffff'
                },
                emphasis: {
                  borderWidth: 3,
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  show: true,
                  position: 'inside'
                }
              }
            }]
          });

        }, 1);
      }
      this.dialogservice.showSplash(false);
    });
  }


}



